export default "__VITE_PUBLIC_ASSET__62154148__"